module.exports = __webpack_public_path__ + "img/telzxbanner.a2e44766.png";